import styled from "styled-components";

export const InstumentTuneStyled = styled.div`
  .tune_history {
    padding: 19px 50px;
    .tune_title {
      margin-bottom: 10px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .tune_sub_title {
      margin-bottom: 5px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
    .tune_row_history {
      margin-bottom: 5px;
      display: flex;
      justify-content: space-between;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      .date_wrap {
        display: flex;
        flex: 1/3;
        column-gap: 5px;
      }
    }
  }

  .theme_standard {
  }
`;
